(function () {
  'use strict';

  document.querySelectorAll('[data-video-trigger]').forEach(function (poster) {
    poster.addEventListener('click', function () {
      var frame = poster.closest('.v2-video__frame');
      if (!frame) return;
      var player = frame.querySelector('[data-video-player]');
      if (!player) return;

      poster.style.display = 'none';
      player.classList.remove('hide');

      var video = player.querySelector('video');
      if (video) video.play();
    });
  });

  document.querySelectorAll('[data-video-fullscreen]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var video = btn.closest('[data-video-player]').querySelector('video');
      if (!video) return;

      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
    });
  });
})();
